import { render, staticRenderFns } from "./DuplicateImport.vue?vue&type=template&id=31db2cf0"
import script from "./DuplicateImport.vue?vue&type=script&lang=js"
export * from "./DuplicateImport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports